import { useEffect, useState } from 'react';

import { useServices } from '@/services/useServices';

export const useEspot = (location, storeId) => {
  const [espot, setEspot] = useState();
  const { espotService } = useServices();

  useEffect(() => {
    const subscription = espotService.getEspotDataByLocation(storeId, location).subscribe((content) => {
      setEspot(content);
    });
    return () => subscription.unsubscribe();
  }, [storeId, location]);

  return espot;
};
